import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import Pagination from '@mui/material/Pagination';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import PageContainer from '../../common/components/PageContainer';
import PageHeader from '../../common/components/PageHeader';

function SC() {
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [selectedPriority, setSelectedPriority] = useState('');

    const getPriorityColor = (prioridade) => {
        switch (prioridade.toLowerCase()) {
            case 'alta':
                return '#d32f2f';
            case 'média':
                return '#ed6c02';
            case 'baixa':
                return '#0288d1';
            default:
                return '#9e9e9e';
        }
    };

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await api.get(`/sc?page=${page - 1}`);
                setData(response.data.content);
                setTotalPages(response.data.page.totalPages);
            } catch (error) {
                console.error("Erro ao buscar dados das Solicitações de compra:", error);
            }
        }
        fetchData();
    }, [page]);

    const handleChange = (event, value) => {
        setPage(value);
    };

    return (
        <PageContainer>
            <PageHeader title="Solicitações de compra">
                <Button variant="outlined" startIcon={<CheckCircleOutlineIcon />} component={Link} to="/sc/aprovados">
                    Aprovadas
                </Button>
                <Button variant="contained" color="secondary" startIcon={<AddCircleOutlineIcon />} component={Link} to="/sc/cadastro">
                    Adicionar SC
                </Button>
            </PageHeader>

            <TextField
                select
                label="Filtrar por Prioridade"
                value={selectedPriority}
                onChange={(e) => setSelectedPriority(e.target.value)}
                size="small"
                sx={{ minWidth: 220, mb: 3 }}
            >
                <MenuItem value="">Todas</MenuItem>
                <MenuItem value="alta">Alta</MenuItem>
                <MenuItem value="média">Média</MenuItem>
                <MenuItem value="baixa">Baixa</MenuItem>
            </TextField>

            <Grid container spacing={2}>
                {data
                    .filter(sc => (!selectedPriority || sc.prioridade.toLowerCase() === selectedPriority) && !sc.status)
                    .map((sc, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <Card sx={{ position: 'relative', overflow: 'hidden' }}>
                                <Box sx={{ position: 'absolute', top: 0, left: 0, bottom: 0, width: 6, bgcolor: getPriorityColor(sc.prioridade) }} />
                                <CardActionArea component={Link} to={`/sc/${sc.id}/orcamento`}>
                                    <CardContent sx={{ pl: 3 }}>
                                        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>{sc.motivo}</Typography>
                                        <Typography variant="body2" color="text.secondary">Número: {sc.numero}</Typography>
                                        <Typography variant="body2" color="text.secondary">Prioridade: {sc.prioridade}</Typography>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </Grid>
                    ))}
            </Grid>

            {totalPages > 1 && (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                    <Pagination count={totalPages} page={page} onChange={handleChange} color="primary" />
                </Box>
            )}
        </PageContainer>
    );
}

export default SC;
